module.exports = __webpack_public_path__ + "media/media/success/globe-f81559d902a2ff68ceaf49ea4efa868a.png";